import MundialRequestTask from "./MundialRequestTask";

export class TeamTask extends MundialRequestTask {
  teamId: string;

  constructor(teamId: string) {
    super();
    this.teamId = teamId;
  }

  getUrl() {
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/teams/${this.teamId}`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/TeamTask.ts